import type { BoardGraph } from '@momentum/shared';

/**
 * Both Momentum worlds (`momentum-section-v1`, the accepted eleven-space section, and
 * `momentum-section-v2`, the expanded world) share the immersive ceramic renderer. They identify
 * themselves through `graph.meta.assetKey`, which is also how the 3D renderer picks the GLB to load,
 * so a future world only needs a new asset key, not another literal-id check in the shell.
 */
export function isMomentumWorld(graph: Pick<BoardGraph, 'meta'>): boolean {
  const key = graph.meta.assetKey;
  return typeof key === 'string' && key.startsWith('momentum-section-');
}
